import $ from 'jquery';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';
import {profile} from '../api/api';

export default class MyData {
	constructor() {
		this.selectors = {
			page: '.js-my-data',
			form: '.js-my-form',
			status: {
				el: {
					desktop: '.js-my-status',
					mobile: '.js-my-status-mob'
				},
				text: '.js-message-text'
			}
		};
		this.classes = {
			message: {
				visible: 'message_state_visible'
			},
			status: {
				visible: 'pa-my-data__status_state_visible',
				error: 'pa-my-data__status_state_error'
			}
		};
		this.$page = $(this.selectors.page);
	}

	getNodes = () => {
		const sel = this.selectors;
		this.$form = this.$page.find(sel.form);
		this.$message = this.$page.find(sel.status.el.mobile);
	}

	setStatusText = (el, text = 'Произошла ошибка') => el.html(text);

	findStatusNode = el => el.find(this.selectors.status.text);

	toggleNode = (el, className, delay = 3000) => {
		el.addClass(className);
		setTimeout(() => el.removeClass(className), delay);
	};

	showStatus = (form, isError = false) => {
		const cls = this.classes;
		const $status = form.find(this.selectors.status.el.desktop);
		if (isViewport(lg)) {
			this.toggleNode(this.$message, cls.message.visible);
		} else {
			this.toggleNode($status, cls.status.visible);
			if (isError) {
				$status.addClass(cls.status.error);
			} else {
				$status.removeClass(cls.status.error);
			}
		}
	}

	onSubmit = e => {
		e.preventDefault();
		const $target = $(e.target);
		const $data = $target.serialize();
		const send = profile($data);
		const $text = isViewport(lg) ? this.findStatusNode(this.$message) : this.findStatusNode($target);
		send.then(
			data => {
				this.showStatus($target);
				this.setStatusText($text, data.message);
			},
			data => {
				this.showStatus($target, true);
				this.setStatusText($text, data.message);
			}
		);
	}

	setHandlers = () => {
		this.$form.on('submit', this.onSubmit);
	}

	render = () => {
		if (this.$page.length) {
			this.getNodes();
			this.setHandlers();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/pa-my-data/index.js
 **/